module.exports = __webpack_public_path__ + "static/media/gameboard-i.f602537f.svg";